module.exports = __webpack_public_path__ + "img/obras3.fd451fb2.svg";